<template>
  <div class="credits-task block-base">
    <div class="title">做任务赚积分</div>

    <!-- 任务列表 -->
    <div class="task-list" mg-stat-show="flag=610" mg-stat-lob="smod=score_task">
      <template v-for="(task, index) in displayTasks" >
        <div 
          class="task-item" 
          v-if="task.taskId !== '22' || (task.taskId === '22' && ad)"
          :class="{ completed: task.completed && task.received }"
          :key="index"
        >
          <div class="task-info">
            <div class="task-header">
              <div class="task-name">{{ task.name }}</div>
              <div class="task-reward">
                <div class="coin-icon"></div>
                <span class="reward-text">
                  <span class="amount">{{ task.reward }}</span>
                </span>
                <div class="task-desc">完成{{ task.curStep }}/{{ task.maxStep }}</div>
              </div>
            </div>
          </div>
          <div class="task-action" 
            :class="{
              'to-complete': !task.completed,
              'to-receive': task.completed && !task.received,
              'received': task.completed && task.received
            }" 
            @click="handleTaskAction(task)"
          >
            {{ getActionText(task) }}
          </div>
        </div>
      </template>
    </div>

    <!-- 展开/收起按钮 -->
    <div class="expand-btn" @click="toggleExpand" v-if="tasks.length > 2">
      {{ isExpanded ? '收起' : '展开' }}
      <img :src="isExpanded ? foldUpIcon : foldDownIcon" alt="fold">
    </div>

    <!-- 积分获取成功弹窗 -->
    <CongratulationDialog
      v-model="taskGetVisible"
      title="成功获得"
      confirmText="立即收下"
      @confirm="onDialogConfirm"
      @close="onDialogClose"
    >
      <div class="content">
        <div class="amount">{{ taskGetScore }}<span>积分</span></div>
      </div>
    </CongratulationDialog>

    <inviteTipDialog v-if="showInviteTip" @close="showInviteTip = false" />
  </div>
</template>

<script>
import foldUpIcon from '../../assets/v2/fold_up.png'
import foldDownIcon from '../../assets/v2/fold_down.png'
import { taskMixin, loginMixin } from '@/utils/mixin';
import TASK_MAP from '../task-list/config';
import { getActivityList } from '@/request/cash';
import { mapGetters } from 'vuex';
import CongratulationDialog from '@/v2-components/dialog/congratulation.vue';
import inviteTipDialog from '@/v2-components/invite-tip-dialog';

export default {
  components: {
    CongratulationDialog,
    inviteTipDialog,
  },
  mixins: [taskMixin, loginMixin],
  data() {
    return {
      isExpanded: false,
      foldUpIcon,
      foldDownIcon,
      tasks: [],
      taskGetVisible: false,
      taskGetScore: '',
      ad: null,
    }
  },
  props: {
    taskList: {
      type: Array,
      default: () => []
    },
  },
  watch: {
    list: {
      handler(listInfo = []) {
        let totalLists = [];

        listInfo.forEach(element => {
          totalLists = totalLists.concat(element.list);
        });

        const uncompletedList = [];
        const completedList = [];
        const receivedList = [];

        for (let item of totalLists) {
          let completed, received;
          
          switch (item.status) {
            case 0:
              completed = false;
              received = false;
              break;
            case 1:
              completed = true;
              received = false;
              break;
            case 2:
              completed = true;
              received = true;
              break;
            default:
              completed = false;
              received = false;
              break;
          }

          const taskItemInfo = {
            name: item.title,
            reward: item.desc,
            curStep: item.curStep,
            maxStep: item.maxStep,
            completed,
            received,
            url: item.url,
            taskId: item.taskId,
          };

          if (completed === false) {
            uncompletedList.push(taskItemInfo);
          } else if (received === false) {
            completedList.push(taskItemInfo);
          } else {
            receivedList.push(taskItemInfo);
          }
        }

        this.tasks = [...completedList, ...uncompletedList, ...receivedList];
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['list', 'isLogin']),
    displayTasks() {
      return this.isExpanded ? this.tasks : this.tasks.slice(0, 2)
    }
  },
  created() {
    // 积分任务
    // this.getPointsTaskInfo(); // 暂定走老接口
    this.isShowAd();
  },
  methods: {
    // 是否显示看广告得积分任务
    isShowAd() {
      MgtvApi.callhandler(
        'requestAd',
        {
          adMethod: 'requestAdResult',
        },
        (data) => {
          let result = JSON.parse(data)
          this.ad = result.data.adResult
          if (this.ad) {
            this.isFinishAdTask()
          }
        }
      )
    },
    // 看广告得积分任务是否完成
    isFinishAdTask() {
      MgtvApi.registerhandler(
        'responseAd',
        {
          adMethod: 'isAdComplete',
        },
        (data) => {
          let result = JSON.parse(data)

          if (result.data.adMethod == 'isAdComplete' && result.data.adResult) {
            this.directNotify(22)
          }
        }
      )
    },
    onDialogConfirm() {
      this.onDialogClose();
    },
    onDialogClose() {
      this.taskGetVisible = false;
      // 刷新用户总积分接口
      this.$store.dispatch('queryCashUserInfo');
    },
    async getPointsTaskInfo() {
      try {
        const { data, code } = await getActivityList({
          listKey: 'CREDIT_POINT_KEYS'  // 拉取签到任务和邀约任务
        });

        if (code === 200) {
          this.tasks = data.TaskInfos.map(item => {
            const taskSetting = item.taskSettings[0];

            let received = false;

            if (taskSetting.gifts) {
              received = taskSetting.gifts.profitState === 2;
            }

            return {
              name: item.taskTitle,
              reward: item.taskDescription,
              completed: item.userTaskStatus === 2,
              received,
              url: item.url,
              taskId: item.taskId,
            }
          });
        }
      } catch (error) {
        console.log('获取积分任务信息失败:', error)
      }
    },
    toggleExpand() {
      // 展开/收起不需要登录检查
      this.isExpanded = !this.isExpanded;
    },
    handleTaskAction(task) {
      const wrappedHandler = this.$wrapClick(() => {
        if (task.completed === false) {
          this.godo(task.taskId, task.url);

          this.reportTaskClick({
            taskid: task.taskId,
            taskidtype: 3,
            status: 0,
          });
        } else if (!task.received) {
          this.goget(task.taskId);

          this.reportTaskClick({
            taskid: task.taskId,
            taskidtype: 3,
            status: 1,
          });
        }
      });
      
      wrappedHandler();
    },
    reportTaskClick({taskid, taskidtype, status}) {
      MgStat.send(
        'click',
        {
          taskid,
          taskidtype,
          status,
        },
        {
          cntp: 'score_newHome',
          mod: 'task',
          cont: '点击任务',
        }
      )
    },
    getActionText(task) {
      // TODO: 检查taskId和config是否能对上
      if (!task.completed) return TASK_MAP[task.taskId]?.btn || '去完成';
      if (!task.received) return '领取';
      return '已领取';
    }
  }
}
</script>

<style scoped lang="less">
@import './index.less';
</style>